import { defineMessages } from 'react-intl'

const scope = `modules.purchasing.features.savePOPDFLabelOverrides.presenters.useSavePOPDFLabelOverridesPresenter`

export default defineMessages({
  successTitle: {
    id: `${scope}.successTitle`,
    defaultMessage: 'Success',
  },
  successMessage: {
    id: `${scope}.successMessage`,
    defaultMessage: '{name} has been updated',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  defaultErrorMessage: {
    id: `${scope}.defaultErrorMessage`,
    defaultMessage: 'Failed to save the label override.',
  },
})
